<template>
  <div class="db-tw-mb-6">
    <div class="db-tw-mb-9 md:db-tw-grid md:db-tw-grid-cols-2 md:db-tw-gap-3">
      <div class="db-tw-mb-9 md:db-tw-mb-0">
        <DbInput
          :modelValue="contactFirstname"
          :inputAttrs="{ required: isMandatoryFirstname }"
          v-on:update:model-value="$emit('update:contactFirstname', $event)"
        >
          {{ labelContactFirstname }}
          <template
            v-if="v$.fieldFirstname.$error"
            v-slot:error
          >
            <DbRfpErrors :errors="v$.fieldFirstname.$errors" />
          </template>
        </DbInput>
      </div>
      <div>
        <DbInput
          :modelValue="contactLastname"
          :inputAttrs="{ required: isMandatoryLastname }"
          v-on:update:model-value="$emit('update:contactLastname', $event)"
        >
          {{ labelContactLastname }}
          <template
            v-if="v$.fieldLastname.$error"
            v-slot:error
          >
            <DbRfpErrors :errors="v$.fieldLastname.$errors" />
          </template>
        </DbInput>
      </div>
    </div>
    <div class="db-tw-mb-9">
      <DbInput
        :modelValue="contactEmail"
        :inputAttrs="{
          type: 'email',
          required: isMandatoryEmail,
        }"
        v-on:update:model-value="$emit('update:contactEmail', $event)"
      >
        {{ labelContactEmail }}
        <template
          v-if="v$.fieldEmail.$error"
          v-slot:error
        >
          <DbRfpErrors :errors="v$.fieldEmail.$errors" />
        </template>
      </DbInput>
    </div>
    <div class="db-tw-mb-9">
      <DbInput
        :modelValue="contactPhone"
        :inputAttrs="{ required: isMandatoryPhone }"
        v-on:update:model-value="$emit('update:contactPhone', $event)"
      >
        {{ labelContactPhone }}
        <template
          v-if="v$.fieldPhone.$error"
          v-slot:error
        >
          <DbRfpErrors :errors="v$.fieldPhone.$errors" />
        </template>
        <template v-slot:hint>
          {{ $t('Phone number with country code. Ex: +33 6 77 82 43 59') }}
        </template>
      </DbInput>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { requiredIf, email, maxLength } from '@/utils/i18n-validators'

const props = withDefaults(
  defineProps<{
    contactFirstname?: string
    contactLastname?: string
    contactEmail?: string
    contactPhone?: string
    labelContactFirstname: string
    labelContactLastname: string
    labelContactEmail: string
    labelContactPhone: string
    isMandatoryFirstname: boolean
    isMandatoryLastname: boolean
    isMandatoryEmail: boolean
    isMandatoryPhone: boolean
  }>(),
  {
    contactFirstname: '',
    contactLastname: '',
    contactEmail: '',
    contactPhone: '',
    alternativePhone: '',
  },
)

defineEmits<{
  (e: 'update:contactFirstname', contactFirstname: string): void
  (e: 'update:contactLastname', contactLastname: string): void
  (e: 'update:contactEmail', contactEmail: string): void
  (e: 'update:contactPhone', contactPhone: string): void
}>()

const state = computed(() => {
  return {
    fieldFirstname: props.contactFirstname,
    fieldLastname: props.contactLastname,
    fieldEmail: props.contactEmail,
    fieldPhone: props.contactPhone,
  }
})

const rules = computed(() => {
  return {
    fieldFirstname: {
      required: requiredIf(props.isMandatoryFirstname),
      maxLengthValue: maxLength(35),
    },
    fieldLastname: {
      required: requiredIf(props.isMandatoryLastname),
      maxLengthValue: maxLength(35),
    },
    fieldEmail: {
      required: requiredIf(props.isMandatoryEmail),
      email,
      maxLengthValue: maxLength(256),
    },
    fieldPhone: { required: requiredIf(props.isMandatoryPhone) },
  }
})

const v$ = useVuelidate(rules, state, { $autoDirty: true })
</script>
